import Settings from 'configs/Settings';
import DateHelper from 'helpers/Date';
import Cookie from 'js-cookie';
import { observable, computed, action } from 'mobx';
import { FeatureToggles, FeatureToggleService } from 'modules/featureToggle';
import { DEFAULT_LOCALE, LOCALES } from 'modules/translation';
import Polyglot from 'node-polyglot';
import enKeys from 'transifex/languages/en.json';
import keys from 'transifex/resources/pt_BR.json';

import { REF_USER } from './constants';

const LOCALE_LENGTH = 2;

class UserStore {
  @observable marketplaceId = '';

  constructor() {
    Object.assign(this, Cookie.getJSON(REF_USER));
  }

  set user(val) {
    if (!val) {
      return;
    }
    this.updateUserCookie(val);
    Object.assign(this, val);
  }

  updateUserCookie(val) {
    const cookie = Cookie.get(REF_USER);
    const data = cookie ? JSON.parse(cookie) : {};

    Object.assign(data, val);

    Cookie.set(REF_USER, data, Settings.cookieConfig);
  }

  @observable name = '';
  @observable photo = '';
  @observable email = '';
  @observable id = null;
  @observable _locale = DEFAULT_LOCALE;
  @observable localeKeys = keys;
  @observable limit = null;
  @observable hasInvalidToken = null;
  @observable pictureThumbUrl = null;
  @observable profileImgUpdate = false;
  @observable roles = [];

  @computed get locale() {
    const locale = LOCALES[this._locale] || DEFAULT_LOCALE;

    return locale.toUpperCase();
  }

  set locale(value) {
    DateHelper.language = value;
    this._locale = value.slice(0, LOCALE_LENGTH).toUpperCase();

    this.setFallbackKeys();
  }

  setFallbackKeys() {
    if (this.shortLocale !== LOCALES.EN && !this.enPolyglot) {
      this.enPolyglot = new Polyglot({ locale: LOCALES.EN, phrases: enKeys });
    }

    if (!this.ptPolyglot) {
      this.ptPolyglot = new Polyglot({ locale: LOCALES.PT, phrases: keys });
    }
  }

  @computed get shortLocale() {
    return this._locale.toLowerCase();
  }

  // eslint-disable-next-line no-dupe-class-members
  set limit(value) {
    this.limit = value;
  }

  @computed get shouldShowMembershipBanner() {
    return FeatureToggleService.isEnabled(FeatureToggles.MembershipBanner);
  }

  @action
  addRoles(roles) {
    this.roles = [...new Set(this.roles.concat(roles))];
  }

  hasRole(role) {
    return this.roles.includes(role);
  }
}

export default new UserStore();
